import React, { useState } from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';

import {
  PaymentElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';

export const PaymentSheet = ({ amount, currency }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    setLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/topup/complete?amount=${amount}&currency=${currency}`,
      },
    });
    setLoading(false);

    if (error) {
      setErrorMessage(error.message);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        maxWidth: '100%',
        width: '100%',
        justifyContent: 'center',
      }}
    >
      <form onSubmit={handleSubmit}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
          }}
        >
          {errorMessage &&
            <Alert
              severity="warning"
              onClose={() => { setErrorMessage(null) }}
            >
              {errorMessage}
            </Alert>
          }
          <PaymentElement />
          <Button
            type="submit"
            disabled={!stripe || !elements || loading}
            fullWidth
            variant="contained"
            color="secondary"
            sx={{
              '&:disabled': {
                color: 'white',
              },
            }}
          >
            {loading ? 'Processing...' : 'Pay'}
          </Button>
        </Box>
      </form>
    </Box>
  )
}
